module.exports = __webpack_public_path__ + "static/media/logo-agep-simple-white.fc4d12c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/assets/img/logo-agep-simple-white.svg
// module id = 873
// module chunks = 0